"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConditionalTokenRegexp = void 0;
const getConditionalTokenRegexp = () => new RegExp(/{# cond-token:1 ([^#]+) #}/, 'gm');
exports.getConditionalTokenRegexp = getConditionalTokenRegexp;
//# sourceMappingURL=conditional-token-regexp.js.map